import { useTranslation } from 'react-i18next';

export default function AppointmentPage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa fa-calendar" /> {t('Appointments', 'Appointments')}
        </h1>
      </div>
      <div className="form-card">
        <div className="empty-state">
          <i className="fa fa-calendar" style={{ fontSize: 48, marginBottom: 12, display: 'block', color: 'var(--mod-schedule)' }} />
          <p>Appointments module — schedule and manage bookings.</p>
          <p className="text-muted">Coming soon</p>
        </div>
      </div>
    </div>
  );
}
